import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Bell, BellOff, BellRing } from "lucide-react";
import { pushSupported, getPushState, subscribePush, unsubscribePush } from "@/lib/push";
import { toast } from "sonner";

export default function PushToggle() {
  const [state, setState] = useState("default");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported()) {
      setState("unsupported");
      return;
    }
    getPushState().then(setState).catch(() => {});
  }, []);

  if (!pushSupported()) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (state === "subscribed") {
        await unsubscribePush();
        setState("default");
        toast.success("Notificações desativadas.");
      } else {
        await subscribePush();
        setState("subscribed");
        toast.success("Notificações ativadas! Você será avisado sobre seus chamados.");
      }
    } catch (e) {
      toast.error(e.message || "Não foi possível ativar as notificações.");
    } finally {
      setBusy(false);
    }
  };

  const Icon = state === "subscribed" ? BellRing : state === "denied" ? BellOff : Bell;
  const title =
    state === "subscribed"
      ? "Notificações ativas (toque para desativar)"
      : state === "denied"
      ? "Notificações bloqueadas nas configurações do navegador"
      : "Ativar notificações no celular";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      disabled={busy || state === "denied"}
      data-testid="push-toggle-button"
      title={title}
    >
      <Icon className={`h-5 w-5 ${state === "subscribed" ? "text-[#1e7be0]" : "text-slate-600"}`} />
    </Button>
  );
}
